import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import condition_management_computed_mixin from "@/utils/mixins/compliance_mixins/condition_management_computed_mixin";
import condition_management_base_methods_mixin from "@/utils/mixins/compliance_mixins/condition_management_base_methods_mixin";
import condition_management_crud_assignment_mixin from "@/utils/mixins/compliance_mixins/condition_management_crud_assignment_mixin";

export default {
  mixins: [
    condition_management_computed_mixin,
    condition_management_base_methods_mixin,
    condition_management_crud_assignment_mixin,
  ],

  mounted() {
    this.$nextTick(() => this.initialize_modals());
    this.current_form_id = this.$route.query.form_id || sessionStorage.getItem("current_form_id");
    this.current_form_name = this.$route.query.form_name || sessionStorage.getItem("current_form_name");
    const rule_id = this.$route.query.rule_id || sessionStorage.getItem("current_rule_id");
    const rule_name = this.$route.query.rule_name || sessionStorage.getItem("current_rule_name");

    if (rule_id) {
      this.selected_rule = { id: rule_id, name: rule_name };
      this.condition_form.rule_id = rule_id;

      this.entity_type_id =
        this.$route.query.entity_type_id || sessionStorage.getItem("entity_type_id");

      this.initializeToken()
        .then(() => {
          this.fetch_all_dropdowns()
            .then(() => this.get_rule_conditions(rule_id))
            .catch(() => this.get_rule_conditions(rule_id));
        })
        .catch(() => this.show_error("Failed to initialize token"));
    } else {
      this.show_error("No rule selected. Please go back and select a rule.");
    }
  },

  methods: {
    initialize_data_table() {
      const table_id = "#condition_management_table";

      this.$nextTick(() => {
        const table_element = document.querySelector(table_id);
        if (!table_element) return;

        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        this.dataTable = $(table_id).DataTable({
          responsive: true,
          autoWidth: false,
          pageLength: 10,
          order: [[9, "desc"]],
          columnDefs: [
            { orderable: false, targets: [9] },
            { searchable: false, targets: [9] },
          ],
          language: {
            emptyTable: "No conditions found",
            zeroRecords: "No matching conditions found",
            info: "Showing _START_ to _END_ of _TOTAL_ conditions",
            infoEmpty: "Showing 0 to 0 of 0 conditions",
            infoFiltered: "(filtered from _MAX_ total conditions)",
            search: "Search:",
            paginate: {
              first: "First",
              last: "Last",
              next: "Next",
              previous: "Previous",
            },
          },
        });
      });
    },
  },

  beforeUnmount() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }

    [this.conditionModal, this.deleteConditionModal].forEach(modal => {
      if (modal) modal.dispose();
    });

    this.show_assign_modal = false;
    this.condition_for_assignment = null;
    this.entity_type_id = null;
  },
};

